/**
 * Maps country code to currency code
 * Based on ISO 3166-1 alpha-2 country codes
 */
export const getCountryCurrency = (countryCode?: string): string => {
  if (!countryCode) {
    return 'EUR'; // Default currency
  }

  const countryToCurrency: Record<string, string> = {
    // Euro zone countries
    AT: 'EUR', // Austria
    BE: 'EUR', // Belgium
    CY: 'EUR', // Cyprus
    EE: 'EUR', // Estonia
    FI: 'EUR', // Finland
    FR: 'EUR', // France
    DE: 'EUR', // Germany
    GR: 'EUR', // Greece
    IE: 'EUR', // Ireland
    IT: 'EUR', // Italy
    LV: 'EUR', // Latvia
    LT: 'EUR', // Lithuania
    LU: 'EUR', // Luxembourg
    MT: 'EUR', // Malta
    NL: 'EUR', // Netherlands
    PT: 'EUR', // Portugal
    SK: 'EUR', // Slovakia
    SI: 'EUR', // Slovenia
    ES: 'EUR', // Spain

    // Non-Euro European countries
    BG: 'BGN', // Bulgaria - Bulgarian Lev
    HR: 'EUR', // Croatia - Euro (since 2023)
    CZ: 'CZK', // Czech Republic - Czech Koruna
    DK: 'DKK', // Denmark - Danish Krone
    HU: 'HUF', // Hungary - Hungarian Forint
    PL: 'PLN', // Poland - Polish Zloty
    RO: 'RON', // Romania - Romanian Leu
    SE: 'SEK', // Sweden - Swedish Krona
    GB: 'GBP', // United Kingdom - British Pound
    CH: 'CHF', // Switzerland - Swiss Franc
    NO: 'NOK', // Norway - Norwegian Krone

    // Other regions
    US: 'USD', // United States
    CA: 'CAD', // Canada
    AU: 'AUD', // Australia
    NZ: 'NZD', // New Zealand
    JP: 'JPY', // Japan
    CN: 'CNY', // China
    BR: 'BRL', // Brazil
    MX: 'MXN', // Mexico
    IN: 'INR', // India
    ZA: 'ZAR', // South Africa
    TR: 'TRY', // Turkey
    RU: 'RUB', // Russia
    AE: 'AED', // United Arab Emirates
    SA: 'SAR', // Saudi Arabia
    AR: 'ARS', // Argentina
    CL: 'CLP', // Chile
    CO: 'COP', // Colombia
    KR: 'KRW', // South Korea
    SG: 'SGD', // Singapore
    MY: 'MYR', // Malaysia
    TH: 'THB', // Thailand
    ID: 'IDR', // Indonesia
    PH: 'PHP', // Philippines
    VN: 'VND', // Vietnam
  };

  return countryToCurrency[countryCode.toUpperCase()] || 'EUR';
};
